module.exports = __webpack_public_path__ + "img/BrowserPreview_tmp.9f38c111.gif";